<template>
  <v-app>
    
    <v-navigation-drawer stateless v-model="drawer" :mini-variant.sync="mini" permanent fill-height app>
              <v-list dense>
              <v-list-item link>
                <v-list-item-icon>
                  <v-icon>mdi-calendar-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>Søg events</v-list-item-title>
                </v-list-item-content>
                    <v-btn
                icon
                @click.stop="mini = !mini"
              >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            </v-list-item>
                <v-container height="100vh" v-if="mini">
        Søg
      </v-container>
            <v-divider></v-divider>
            
          </v-list>
            <v-container v-if="!mini">
    <!-- The Search component -->
            <SearchForm />
            </v-container>

    </v-navigation-drawer>
  
    <v-content class="sticky">
      <Map class="ma-0 pa-0"/>
    </v-content>
    

  </v-app>
</template>

<script>
import SearchForm from "@/components/SearchForm.vue";
import Map from "@/components/Map.vue";

export default {
  name: "App",
  components: {
    SearchForm,
    Map,
  },

  props: {
    source: String,
  },
  data: () => ({
    drawer: true,
    newData: undefined,
    mini: false,
  }),
  mounted: function () {
    this.$root.$on("newData", (newData) => {
      this.newData = newData;
    });
    this.$root.$on('closeDrawer',(val) => {
          this.mini = val;
    });
  },
  methods: {
 
    formatDate(datestring) {
      let date = new Date(datestring);
      let mm = date.getMonth();
      let dd = date.getDate();
      let day = date.getDay();
      //let yyyy = date.getFullYear()
      var months = [
        "januar",
        "februar",
        "marts",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december",
      ];
      var days = ["Man", "Tirs", "Ons", "Tors", "Fre", "Lør", "Søn"];

      date = days[day] + " d. " + dd + ". " + months[mm];

      return date;
    },
  },
};
</script>
<style>
body{
      font-family: "Roboto Condensed",sans-serif;

}
  
</style>
<style scoped>
.sticky {
  position: sticky;
}
.hojt {
  height: 100%;
}
.extra-height {
  height: 60px;
}
.hei {
  min-height: 140px;
}
.overTitle {
  padding: 0px 13px 8px 13px;
  margin-bottom: 3px;
  font-size: 12px;
  color: #ffffff;
}
.rubrik {
  padding: 13px 13px 0px 13px;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
}
.teksten {
  padding: 0px 13px 13px 13px;
  color: #ffffff;
  font-size: 14px;
}
</style>